import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../../common/http/http-utils';
@Injectable()
export class Service {
  value = '';
  constructor(public http: HttpClient) {}

 createNetwork(config, payload) {
    let urlParams = config.vdcId ? '?orgVdcId=' + config.vdcId : '?vcHost=' + config.vcUrl;
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/directConnect/' + config.name + urlParams;
    return this.http
      .put(url, JSON.stringify(payload))
      .map(
        (res: any) => this.value = res
      );
  }

  updateUplinksOfEdge(data, edgeId) {
      let url = HttpUtils.getBaseUrl() + '/hybridity/api/edge/' + edgeId + '/directConnects';
      return this.http
        .put(url, JSON.stringify(data))
        .map(
          (res: any) => this.value = res
      );
}


  logError(error, origin: String = '') { 
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }

  logOperationCompleted(msg: string) {
    console.log( 'Operation Completed: ', msg );
  }
}


// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/dialog/connect-network/connect-network.service.ts